import { TextField, Autocomplete, Stack, Typography } from '@mui/material';

const DEFAULT_MAX_CHIP = 10;

const RpKeywordsFilter = (props) => {
    const maxChip = props.maxChip || DEFAULT_MAX_CHIP;

    const handleKeywordsChange = (_, newValue) => {
        if (newValue.length <= maxChip) {
            if (props.onChange) {
                props.onChange(newValue);
            }
        }
    };

    return (
        <>
            <Stack spacing={2} mb={1.5}>
                <Typography variant="text1" gutterBottom>{props.label || 'Keyword Search'}</Typography>
            </Stack>
            <Stack spacing={2} mb={1}>
                <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={(theme) => ({
                        color: theme.palette.tertiary.light,
                        fontWeight: '400',
                        display: 'flex',
                        justifyContent: 'space-between',
                    })}
                >
                    <span>
                        {props.subLabel || 'To add multiple Keywords hit ‘Enter’ after typing'}
                    </span>
                    <Typography
                        sx={(theme) => ({
                            color: props.value.length ? theme.palette.primary.main : 'inherit'
                        })}>
                        {`${props.value.length}/${maxChip}`}
                    </Typography>
                </Typography>
            </Stack>
            <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={props.value}
                onChange={handleKeywordsChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Enter Keyword"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderWidth: 1,
                                },
                                '& .MuiInputBase-input': {
                                    height: '23px',
                                    visibility: props.value.length === maxChip ? 'hidden' : 'visible',
                                },
                            },
                        }}
                    />
                )}
            />
        </>
    );
};

export default RpKeywordsFilter;